import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    min: { type: Number },
    max: { type: Number },
    decimals: { type: Number, default: 0 }
  }

  connect() {
    this.clamp()
  }

  clamp(event) {
    const input = this.element
    if (input.type !== "number") return

    const value = parseFloat(input.value)
    const isBlur = !event || event.type === "change"

    if (Number.isNaN(value)) {
      if (isBlur) input.value = 0
      return
    }

    let clamped = value
    if (this.hasMinValue && value < this.minValue) clamped = this.minValue
    if (this.hasMaxValue && value > this.maxValue) clamped = this.maxValue

    if (isBlur) {
      if (this.hasDecimalsValue && this.decimalsValue >= 0) {
        const factor = 10 ** this.decimalsValue
        clamped = Math.round(clamped * factor) / factor
      }
      input.value = this.hasDecimalsValue && this.decimalsValue >= 0
        ? clamped.toFixed(this.decimalsValue)
        : String(clamped)
    } else {
      // On input: only overwrite when we had to clamp to min/max
      if (clamped !== value) input.value = String(clamped)
    }
  }
}
